import { Controller, Payload } from "../../controller";
import { ApplicationState } from "../../store";
import { bindActionCreators, Dispatch } from "redux";

import { Contas, initialValueContasState, ContasState, ContasActions, ContasGroup, ResumoMeioPagRecebido, MeioPagSelectedConta, ReceberPagamento, NovaConta } from "./contas.model"
import { ClienteActions } from "../cliente/cliente.model";
import { clienteController } from "../cliente/cliente.controll";
import { FornecedorActions } from "../fornecedor/forn.model";
import { fornecedorController } from "../fornecedor/forn.controll";
import { call, put, takeLatest } from "redux-saga/effects";
import { action } from "typesafe-actions";
import { ResultDb } from "../../services/db";
import { canalDistController } from "../canalDist/canalDist.controll";
import { ResumoContasPessoa } from "../../data.types";
import { getNewId } from "../../services/utils";


export interface ContasViewProps {
    contasState: ContasState
    contasActions: ContasActions
    clienteActions: ClienteActions
    fornecedorActions: FornecedorActions
}


class ContasController extends Controller<Contas, ContasState, ContasActions> {
    constructor() {
        super(initialValueContasState.row.type, initialValueContasState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            setContasGroup: `@${this.moduloName}/SET_CONTAS_GROUP`,
            setContaGroup: `@${this.moduloName}/SET_CONTA_GROUP`,
            handleNovaConta: `@${this.moduloName}/HANDLE_NOVA_CONTA`,
            receberPagamento: `@${this.moduloName}/RECEBER_PAGAMENTO`,
            setContaResumoSelected: `@${this.moduloName}/SET_CONTA_RESUMO_SELECTED`,
            setMeioPagSelectedConta: `@${this.moduloName}/SET_MEIO_PAG_SELECTED_CONTA`,
            readContasDetalheByPessoa: `@${this.moduloName}/READ_CONTAS_DETALHE_BY_PESSOA`,
            readResumoMpRecebimentosByCanal: `@${this.moduloName}/READ_RESUMO_MP_RECEBIMENTOS`,
            readResumoContas: `@${this.moduloName}/READ_RESUMO_CONTAS`,
            setTabValue: `@${this.moduloName}/SET_TAB_VALUE`,
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            setContasGroup: (rows: Contas[]) => action(this.actionsType.setContasGroup, { rows }),
            setContaGroup: (contaGroup: ContasGroup) => action(this.actionsType.setContaGroup, { contaGroup }),
            handleNovaConta: (prm) => action(this.actionsType.handleNovaConta, { prm }),
            receberPagamento: (value: ReceberPagamento) => action(this.actionsType.receberPagamento, { value }),
            setContaResumoSelected: (contaResumo: ResumoContasPessoa) => action(this.actionsType.setContaResumoSelected, { contaResumo }),
            setMeioPagSelectedConta: (meioPagSelected: MeioPagSelectedConta) => action(this.actionsType.setMeioPagSelectedConta, { meioPagSelected }),
            readContasDetalheByPessoa: (pessoaId: string) => action(this.actionsType.readContasDetalheByPessoa, { pessoaId }),
            readResumoMpRecebimentosByCanal: (canalId: string) => action(this.actionsType.readResumoMpRecebimentosByCanal, { canalId }),
            readResumoContas: (tipo: "receber" | "pagar") => action(this.actionsType.readResumoContas, { tipo }),
            setTabValue: (value: number) => action(this.actionsType.setTabValue, { value })
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.resultAfterEffcts, this.resultAfterContasEffect.bind(this)),
            takeLatest(this.actionsType.setContasGroup, this.setContasGroupActionEffects.bind(this)),
            takeLatest(this.actionsType.setContaGroup, this.setContaGroupEffects.bind(this)),
            takeLatest(this.actionsType.handleNovaConta, this.handleNovaContaEffect.bind(this)),
            takeLatest(this.actionsType.readResumoMpRecebimentosByCanal, this.readResumoMpRecebimentosByCanalEffects.bind(this)),
            takeLatest(this.actionsType.receberPagamento, this.receberPagamentoEffects.bind(this)),
            takeLatest(this.actionsType.setContaResumoSelected, this.setContaResumoSelectedEffects.bind(this)),
            takeLatest(this.actionsType.setMeioPagSelectedConta, this.setMeioPagSelectedContaEffects.bind(this)),
            takeLatest(this.actionsType.readContasDetalheByPessoa, this.readContasDetalheByPessoaEffects.bind(this)),
            takeLatest(this.actionsType.readResumoContas, this.readResumoContasEffects.bind(this)),
            takeLatest(this.actionsType.setTabValue, this.setTabValueEffect.bind(this)),
        ]
    }


    private * setTabValueEffect(actions: Payload) {
        const { value } = actions.payload as { value: number };
        yield put(this.reducer.resultAfterEffects(
            { ...this.state, tabValue: actions.payload.value },
            this.actionsType.setTabValue
        ))
    }


    private * receberPagamentoEffects(actions: Payload) {
        try {
            const { pessoaId, valor, canalDist, meioPag, contasDetalhes } = actions.payload.value as ReceberPagamento;
            console.log("Recebendo pagamento para pessoaId:", pessoaId, " valor:", valor);
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, msg: "Processando recebimento de pagamento...", status: "loading", error: false, showAlert: false },
                this.actionsType.receberPagamento
            ))
            //lógica para processar recebimento de pagamento aqui

            //fazer um filtro para buscas as contas da pessoa com saldo em aberto e ir dando baixa até o valor zerar
            //caso o valor seja menor que o saldo total, dar baixa parcial na última conta

            if (contasDetalhes && contasDetalhes.length > 0) {
                let saldoRestante = valor;
                for (let conta of contasDetalhes as Contas[]) {
                    if (saldoRestante <= 0) break;

                    let valorConta = conta.valor - conta.recebimentos.reduce((acc, rec) => acc + rec.valor, 0);
                    let valorRecebido = saldoRestante >= valorConta ? valorConta : saldoRestante;

                    //adicionar recebimento na conta
                    conta.recebimentos.push({
                        _id: getNewId(), //gerar um id único
                        valor: valorRecebido,
                        canal_dist: canalDist,
                        data: new Date().toISOString(),
                        meio_pag: meioPag
                    });

                    //verificar se a conta foi totalmente paga, e colocar situação como "pago" se nao colocar "parcial"
                    let totalRecebido = conta.recebimentos.reduce((acc, rec) => acc + rec.valor, 0);
                    conta.situacao = totalRecebido >= conta.valor ? "pago" : "parcial";

                    //atualizar a conta no banco
                    yield call(this.db.updateData, conta);
                    
                    saldoRestante -= valorRecebido;
                }
            } else {
                console.log("Nenhuma conta em aberto encontrada para a pessoa:", pessoaId);
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, msg: "Nenhuma conta em aberto encontrada para essa pessoa.", status: "error", error: true, showAlert: true },
                    this.actionsType.receberPagamento
                ))
                return;
            }
            //recarregar o resumo das contas
            yield put(this.reducer.actions.readResumoContas("receber"));

            yield put(this.reducer.actions.readContasDetalheByPessoa(pessoaId));

            yield put(this.reducer.resultAfterEffects(
                {
                    ...this.state,
                    msg: "Pagamento recebido com sucesso!",
                    status: "ok",
                    error: false,
                    showAlert: true,

                    loading: false,
                    meioPagSelectedConta: {} as MeioPagSelectedConta,

                },
                this.actionsType.receberPagamento
            ))

        } catch (error: any) {
            console.log("error receberPagamentoEffects", error);
            let msg = "Ops, ocorreu uma falha em receberPagamentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.receberPagamento
            ))
        }
    }

    private * setContaResumoSelectedEffects(actions: Payload) {
        try {
            const contaResumo: ResumoContasPessoa = actions.payload.contaResumo
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, contaResumoSelected: contaResumo },
                this.actionsType.setContaResumoSelected
            ))
            yield put(this.reducer.actions.readContasDetalheByPessoa(contaResumo.key._id))
        } catch (error: any) {
            console.log("error setContaResumoSelectedEffects", error);
            let msg = "Ops, ocorreu uma falha em setContaResumoSelectedEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.setContaResumoSelected
            ))
        }
    }

    private * setMeioPagSelectedContaEffects(actions: Payload) {
        try {
            const meioPagSelected: MeioPagSelectedConta = actions.payload;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, meioPagSelectedConta: meioPagSelected },
                this.actionsType.setMeioPagSelectedConta
            ))
        } catch (error: any) {
            console.log("error setMeioPagSelectedContaEffects", error);
            let msg = "Ops, ocorreu uma falha em setMeioPagSelectedContaEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.setMeioPagSelectedConta
            ))
        }
    }


    private * readContasDetalheByPessoaEffects(actions: Payload) {
        try {
            const pessoaId: string = actions.payload.pessoaId;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, msg: "Carregando contas detalhadas...", status: "loading", error: false, showAlert: false },
                this.actionsType.readContasDetalheByPessoa
            ))
            let respContas: ResultDb<Contas> = yield call(this.db.filterView, {
                viewName: "func/contas_receber_detalhe_by_pessoa",
                opt: {
                    key: pessoaId,
                    include_docs: true,
                },
                resultViewFull: false
            })
            console.log("result readContasDetalheByPessoaEffects", respContas);
            if (respContas.status === "ok" && respContas.rows) {
                let contas = respContas.rows.sort((a: Contas, b: Contas) => {
                    if (a.created_at < b.created_at)
                        return -1
                    if (a.created_at > b.created_at)
                        return 1
                    return 0
                })
                console.log("Contas detalhadas ordenadas por data de criação:", contas);
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, status: "ok", msg: "Contas detalhadas carregadas.", rows: contas as Contas[],changeList: new Date().toISOString() },
                    this.actionsType.readContasDetalheByPessoa
                ))

            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, msg: respContas.msg as string, status: "error", error: true, showAlert: true, rows: [] },
                    this.actionsType.readContasDetalheByPessoa
                ))
            }
        } catch (error: any) {
            console.log("error readContasDetalheByPessoaEffects", error);
            let msg = "Ops, ocorreu uma falha em readContasDetalheByPessoaEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.readContasDetalheByPessoa
            ))
        }
    }


    private * readResumoContasEffects(actions: Payload) {
        try {
            const tipo: "receber" | "pagar" = actions.payload.tipo;
            console.log("Buscando resumo contas a receber...");
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, msg: "Buscando contas a receber abertas...", status: "loading", error: false, showAlert: false },
                this.actionsType.readResumoContas
            ))

            let resp: ResultDb<ResumoContasPessoa> = yield call(this.db.filterView, {
                viewName: tipo === "receber" ? "func/contas_receber_aberta_resumo_by_pessoa" : "func/contas_pagar_aberta_resumo_by_pessoa",
                opt: { group_level: 1 },
                resultViewFull: true
            })
            console.log("result readResumoContasEffects", resp);
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, status: "ok", msg: "Busca das contas concluidas.", contas_resumo: resp.rows as ResumoContasPessoa[], changeList: new Date().toISOString() },
                    this.actionsType.readResumoContas
                ))

            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, msg: resp.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.readResumoContas
                ))
            }

        } catch (error: any) {
            console.log("error readResumoContasEffects", error);
            let msg = "Ops, ocorreu uma falha em readResumoContasEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.readResumoContas
            ))
        }

    }

    private * resultAfterContasEffect(actions: Payload) {
        //const this = actions.payload.this as ContasController
        let actionType = actions.payload.actionType;
        try {
            let state: ContasState = actions.payload.result;
            let tipo:any = state.tabValue === 0 ? "receber" : "pagar";
            if (state.status === "ok") {
                switch (actionType) {
                    case this.actionsType.read:
                        yield put(this.reducer.actions.readResumoContas(tipo));
                        break;
                    case this.actionsType.readView:
                        yield put(this.reducer.actions.readResumoContas(tipo));
                        break;
                    case this.actionsType.create:
                        yield put(this.reducer.actions.readResumoContas(tipo));
                        break;
                    case this.actionsType.update:
                        yield put(this.reducer.actions.readResumoContas(tipo));
                        break;
                    case this.actionsType.deleta:
                        yield put(this.reducer.actions.readResumoContas(tipo));
                        break;
                }
            }
        } catch (error: any) {
            console.log("error resultAfterContasEffect", error);
            let msg = "Ops, ocorreu uma falha em resultAfterContasEffect, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.resultAfterContasEffect
            ))
        }
    }

    private * readResumoMpRecebimentosByCanalEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, msg: "Carregando resumo de recebimentos por meio de pagamento...", status: "loading", error: false, showAlert: false },
                this.actionsType.READ_RESUMO_MP_RECEBIMENTOS
            ))
            let canalId = actions.payload.canalId;
            let respResumoMP: ResultDb<any> = yield call(this.db.filterView, {
                viewName: "func/contas_receber_mp_resumo_by_canaldist_id",
                opt: {
                    startkey: [canalId],
                    endkey: [canalId, {}],
                    group_level: 2,
                },
                resultViewFull: true
            })
            console.log("result readResumoMpRecebimentosEffects", respResumoMP);
            if (respResumoMP.status === "ok") {
                //loop para converter os dados para o formato ResumoMeioPagRecebido
                if (respResumoMP.rows && respResumoMP.rows.length > 0) {
                    let resumoMP = respResumoMP.rows.map((item: any, idx: number) => {
                        return {
                            _id: idx,
                            descricao: item.key[1],
                            valor: item.value
                        } as ResumoMeioPagRecebido
                    })
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loadingRows: false, status: "ok", msg: "Resumo de recebimentos por meio de pagamento carregado.", resumoMeiopagRecebidos: resumoMP },
                        this.actionsType.READ_RESUMO_MP_RECEBIMENTOS
                    ))
                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loadingRows: false, status: "ok", msg: "Resumo de recebimentos por meio de pagamento carregado.", resumoMeiopagRecebidos: [] },
                        this.actionsType.READ_RESUMO_MP_RECEBIMENTOS
                    ))
                }
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, msg: respResumoMP.msg as string, status: "error", error: true, showAlert: true },
                    this.actionsType.READ_RESUMO_MP_RECEBIMENTOS
                ))
            }
        } catch (error: any) {
            console.log("error readResumoMpRecebimentosEffects", error);
            let msg = "Ops, ocorreu uma falha em readResumoMpRecebimentosEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.READ_RESUMO_MP_RECEBIMENTOS
            ))
        }
    }


    private * setContasGroupActionEffects(actions: Payload) {
        let rows: Contas[] = actions.payload.rows
        let contasGroup: ContasGroup[] = rows.reduce((groups: any, conta) => {
            const tipo = conta.tipo;
            if (groups.length === 0 || !groups[tipo]) {
                groups["pagar"] = {
                    tipo: "Pagar",
                    contas: []
                };
                groups["receber"] = {
                    tipo: "Receber",
                    contas: []
                };
            }
            groups[tipo].contas.push(conta);
            return groups;
        }, {});
        const contasGroupArray = Object.values(contasGroup);
        console.log("Grouped Contas:", contasGroupArray);
        let contaGroup = this.state.contaGroup;
        if (contaGroup.tipo != "") {
            contaGroup = { ...structuredClone(contasGroupArray.find(cg => cg.tipo === contaGroup.tipo)!) };
            console.log("Selected ContaGroup:", contaGroup);
        }

        yield put(this.reducer.resultAfterEffects({
            ...this.state,
            contasGroup: contasGroupArray,
            contaGroup: contaGroup,
        }, this.actionsType.setContasGroup));
    }

    private * setContaGroupEffects(actions: Payload) {
        let contaGroup: ContasGroup = actions.payload.contaGroup
        yield put(this.reducer.resultAfterEffects({
            ...this.state,
            contaGroup: contaGroup
        }, this.actionsType.setContaGroup));
    }

    private * handleNovaContaEffect(actions: Payload) {
        console.log("handleNovaContaEffect chamado com payload:", actions.payload);
        const prm = actions.payload.prm as NovaConta;
        let newConta: Contas = {
            ...this.getInitialValue(),
            ...prm,
        }
        yield put(this.reducer.resultAfterEffects({
            ...this.state,
            row: newConta,
            showCadModal: true,
        }, this.actionsType.handleNovaConta));
    }

    novaConta = async (novaConta: NovaConta): Promise<ResultDb<Contas>> => {
        try {
            console.log("Criando nova conta a receber...", novaConta);
            let newConta: Contas = {
                ...this.getInitialValue(),
                ...novaConta,
                situacao: "aberto",
                created_at: new Date().toISOString(),
            }
            let resp = await this.db.salvar(newConta);
            if (resp.status !== "ok") {
                return { status: "error", msg: resp.msg as string };
            }
            return { status: "ok", msg: "Conta criada com sucesso!", row: resp.row } as ResultDb<Contas>;
        } catch (error) {
            return {
                status: "error",
                msg: "Ops, ocorreu uma falha em criar nova conta, detalhes: " + (typeof error === 'object' ? JSON.stringify(error) : error)
            } as ResultDb<Contas>;
        }
    }    
}

export const contasController = new ContasController()

export const mapStateToContasProps = (state: ApplicationState) => ({
    contasState: state.contasState,
})

export const mapDispatchToContasProps = (dispatch: Dispatch) => ({
    contasActions: bindActionCreators({ ...contasController.reducer.actions }, dispatch),
    clienteActions: bindActionCreators({ ...clienteController.reducer.actions }, dispatch),
    fornecedorActions: bindActionCreators({ ...fornecedorController.reducer.actions }, dispatch),
})